import React from 'react';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { connect } from 'react-redux';
import cn from 'classnames';

import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';
import {
  selectCurrentSalonAllowanceYear,
  selectCurrentSalonAllowanceYearStart,
} from 'selectors/currentSalon.selectors';
import fromAnyToString from 'utils/converters/fromAnyToString';
import { formatDayToYearOrdinal } from 'utils/date/format.util';
import parseDate from 'utils/parsers/parseDate';
import c from 'utils/values/constant.util';

import CN from './FilterReports.module.scss';

const TIME_OFF_YEAR_RANGE = c({
  taxYear: 'Tax Year',
  calendarYear: 'Calendar Year',
  customYear: 'Custom',
});

const FilterReports = ({ tableId, allowanceYear, allowanceYearStart, children }) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  const currentYear = new Date().getFullYear();
  const nextYear = new Date().getFullYear() + 1;

  const displayTaxYear = `6 April ${currentYear} - 5 April, ${nextYear}`;
  const displayCalendarYear = `1 Jan - 31 Dec, ${currentYear}`;
  // TODO: extracted in src/utils and/or src/bl and add some tests
  const allowanceYearEnd = new Date(parseDate(allowanceYearStart));
  allowanceYearEnd.setDate(allowanceYearEnd.getDate() + 365);

  const allowanceYearEndString = fromAnyToString(allowanceYearEnd);

  const displayCustomYear = `${formatDayToYearOrdinal(allowanceYearStart)} - ${formatDayToYearOrdinal(
    allowanceYearEndString,
  )}`;

  const DATA_MAP = {
    [TIME_OFF_YEAR_RANGE.calendarYear]: displayCalendarYear,
    [TIME_OFF_YEAR_RANGE.taxYear]: displayTaxYear,
    [TIME_OFF_YEAR_RANGE.customYear]: displayCustomYear,
  };

  const renderedData = DATA_MAP[allowanceYear];

  return (
    <div
      data-bem="FilterReports"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <span className={CN.title}>{renderedData}</span>

      <div className={CN.flex}>
        <div className={CN.buttonContainer}>
          {children}
          <ReactHTMLTableToExcel
            className={CN.excelButton}
            table={tableId}
            filename="Stylists holiday"
            sheet="Stylists holiday"
            buttonText={t('staffKpisReports.reportsTimeOff.exportButton')}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  allowanceYear: selectCurrentSalonAllowanceYear(state),
  allowanceYearStart: selectCurrentSalonAllowanceYearStart(state),
});

const FilterReportsHoc = connect(mapStateToProps)(FilterReports);

export default FilterReportsHoc;
